import { Component, OnInit } from '@angular/core';
import { UsersService } from '../services/users.service'
import { NgForm } from '@angular/forms'
import { Router} from '@angular/router';
import swal from 'sweetalert2'


@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  isLoading = false
  error = false
  token:string = null

  constructor(private authService:UsersService, private router:Router) {
  }

  ngOnInit() {
      if (this.authService.currentUser) {
          this.router.navigate(['/dashboard'])
      }
  }

  onCaptchaResponse(response:any) {
    this.token = response
  }

  forgotPWD() {
    swal({
      title: '請輸入您的帳號',
      input: 'email',
      showCancelButton: true,
      confirmButtonText: '確定',
      showLoaderOnConfirm: true,
      preConfirm: (email) => {
        return this.authService.sendResetEmail(email)
      },
      allowOutsideClick: false
    }).then(function(email) {
      swal({
        type: 'success',
        title: '重置密碼信件已寄出'
      })
    })
  }

  onSubmit(f:NgForm) {
    this.isLoading = true
    this.error = false
    this.authService.signInUser(f.value.email,f.value.password).catch(
      err => {
        this.isLoading = false
        this.error = true
      }
    )
    // this.authService.siteverify(this.token).subscribe(
    //   res => {
    //     console.log(res)
    //     if (res.json().success) {
    //       this.authService.signInUser(f.value.email,f.value.password).catch(
    //         err => {
    //           this.isLoading = false
    //           this.error = true
    //           alert(err.toString())
    //         }
    //       )
    //     }else {
    //       this.isLoading = false
    //       this.error = true
    //       console.log('驗証失敗')
    //     }
    //
    //   }
    // )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login.component.ts